var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('button',{staticClass:"button button--ghost",attrs:{"type":"button"},on:{"click":function($event){return _vm.back()}}},[_c('i',{staticClass:"icon-chevron-left button__icon button__icon--left"}),_vm._v(" "),_c('T',[_vm._v("Vorige stap")])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6e49cb88","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/components/BackButton.vue
// module id = 547
// module chunks = 0